import type { InventoryTabItemName } from '../InventoryStore';

import { useRowState } from './useRowState';

/**
 * Hook for read-only row configurations.
 * Returns only the necessary state: dateKeys and inventory data
 */
export const useReadOnlyRowConfig = (entityType: InventoryTabItemName) => {
  const { dateKeys, inventoryRooms, inventoryExperiences, inventoryPacks } =
    useRowState(entityType);

  return {
    dateKeys,
    inventoryRooms,
    inventoryExperiences,
    inventoryPacks,
  };
};
